import type { MatchStatus } from "@/types";

interface StatusBadgeProps {
  status: MatchStatus;
  period?: string;
}

export default function StatusBadge({ status, period }: StatusBadgeProps) {
  if (status === "live") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
        <span className="relative flex w-2 h-2 items-center justify-center">
          <span className="absolute inline-flex w-2 h-2 rounded-full bg-background-50 animate-live-pulse" />
          <span className="relative inline-flex w-1.5 h-1.5 rounded-full bg-background-50" />
        </span>
        {period ? `直播中 · ${period}` : "直播中"}
      </span>
    );
  }
  if (status === "upcoming") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-700">
        <i className="ri-time-line" />
        即将开赛
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
      <i className="ri-replay-10-line" />
      回放
    </span>
  );
}